import * as React from "react";

import type { CompletionEntry } from "shared/dist/types/types";

import { Autocomplete } from "@/components/Autocomplete";
import { getContent } from "@/utils/fetch";
import { replaceIgnoreCase } from "@/utils/utils";

const renderSuggestion = (
    suggestion: CompletionEntry,
    { query }: { query: string }
): JSX.Element => (
    <div className="d-flex align-items-center">
        <div className="img-app-small me-2">
            <img src={suggestion.value} alt="" />
        </div>
        <div>
            <span
                dangerouslySetInnerHTML={{
                    __html: replaceIgnoreCase(
                        suggestion.label ?? "",
                        query,
                        '<span class="autosuggest-query">' + query + "</span>"
                    ),
                }}
            />
        </div>
    </div>
);
const autocomplete = (input: string): Promise<CompletionEntry[]> =>
    getContent(`completion/wpImg/${encodeURIComponent(input)}`);

export const ImageSuggestions = (props: {
    onChange(value: string): void;
    defaultValue?: string | null;
}): JSX.Element => {
    const [currentValue, setCurrentValue] = React.useState(
        props.defaultValue || ""
    );
    const onChange = (
        _event: React.FormEvent<HTMLElement>,
        { newValue }: { newValue: string }
    ): void => {
        setCurrentValue(newValue);
        props.onChange(newValue);
    };

    return (
        <Autocomplete
            value={currentValue}
            onChange={onChange}
            getSuggestions={autocomplete}
            renderSuggestion={renderSuggestion}
            inputProps={{ maxLength: 200 }}
        />
    );
};
